export interface IStorage {
  save(key: string, value: string): void;
  delete(key: string): void;
  read(key: string): string | null;
}